// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NumberInput, Input } from "../../../revvComponents";
// Components Imports
import { ReactSelect } from "../../../commonComponents";

// Internal Imports
import { WORKFLOW } from "../../../constants";

// Destructuring
const { CONDITION_OPERATOR, OPERATORS_MAPPING } = WORKFLOW;

function _pickOperatorBasedOnAttribute(index, data, attributes) {
  const { conditions } = data;
  if (conditions[index] && conditions[index].param) {
    const condition = attributes.find(
      item => item.name === conditions[index].param,
    );
    const operatorType = condition && condition.type;
    return operatorType ? CONDITION_OPERATOR[operatorType] : [];
  }
  return [];
}

function _decideOperator(data) {
  return data.logicalOperator === "AND" ? "OR" : "AND";
}

function _decideValueField(
  // Data Props
  attributes,
  data,
  index,
  // Function Props
  onSelectChange,
  onInputChange,
) {
  const { conditions = [] } = data;
  if (conditions[index] && conditions[index].param) {
    const column = attributes.find(
      item => item.name === conditions[index].param,
    );
    switch (column && column.type) {
      case "SingleSelectField":
        return (
          <ReactSelect
            isSearchable
            options={column.props}
            value={conditions[index].value || ""}
            onChange={value => onSelectChange("value", value, index)}
            data-test="wfconditionslist-singleselect"
          />
        );
      case "NumericField":
        return (
          <NumberInput
            placeholder="Enter Value"
            value={conditions[index].value || ""}
            onChange={event => onInputChange("value", event, index, true)}
            data-test="wfconditionslist-numericfield-input"
          />
        );
      case "PercentField":
        return (
          <NumberInput
            placeholder="Enter Value"
            value={conditions[index].value || ""}
            isFloat
            limitTo={100}
            onChange={event => onInputChange("value", event, index, true)}
            data-test="wfconditionslist-percentagefield-input"
          />
        );
      default:
        return (
          <Input
            placeholder="Enter Value"
            value={conditions[index].value || ""}
            onChange={event => onInputChange("value", event, index, false)}
            data-test="wfconditionslist-default-inputt"
          />
        );
    }
  }
  return (
    <Input
      placeholder="Enter Value"
      value={conditions[index].value || ""}
      onChange={event => onInputChange("value", event, index, false)}
      data-test="wfconditionslist-value-input"
    />
  );
}

const WFConditionsList = ({
  // Data Props
  data,
  attributes,
  index,
  condition,
  // Function Props
  toggleLogicalOperatorVisibility,
  onSelectChange,
  onRemoveCondition,
  onInputChange,
}) => {
  const { conditions, logicalOperator, showOperators } = data;
  const totalEntries = (conditions && conditions.length - 1) || 0;

  return (
    <div>
      <div className="wfconditionslist-list-wrapper" key={condition.id}>
        <div className="wfconditionslist-title-wrapper">
          <div className="wfconditionslist-list-title">
            Condition {index + 1}
          </div>
          <span
            className="wfconditionslist-delete-ico"
            onClick={() => onRemoveCondition(index)}
            onKeyPress={() => onRemoveCondition(index)}
            role="button"
            tabIndex="0">
            <FontAwesomeIcon icon={["far", "trash-alt"]} />
          </span>
        </div>
        <div className="wfconditionslist-split-wrapper">
          <div className="wfconditionslist-div-wrapper">
            <span className="revvform-label">
              Select Deal table view attribute
            </span>
            <ReactSelect
              options={attributes}
              value={condition.param}
              valueKey="name"
              onChange={value => onSelectChange("param", value, index)}
              data-test="wfconditionslist-attribute-select"
            />
          </div>
          <div className="wfconditionslist-div-wrapper">
            <span className="revvform-label">Operator</span>
            <ReactSelect
              options={_pickOperatorBasedOnAttribute(index, data, attributes)}
              value={OPERATORS_MAPPING[condition.rel_op]}
              onChange={value => onSelectChange("rel_op", value, index)}
              data-test="wfconditionslist-operator-select"
            />
          </div>
        </div>
        <div className="wfconditionslist-div-wrapper">
          <span className="revvform-label">Value</span>
          {_decideValueField(
            // Data Props
            attributes,
            data,
            index,
            // Function Props
            onSelectChange,
            onInputChange,
          )}
        </div>
        {/**
        <div className="wfconditionslist-div-wrapper">
          <span className="revvform-label">
            Expression on triggering this condition
          </span>
          <Input
            placeholder="Enter Expression"
            value={condition.trigger_message}
            onChange={event =>
              onInputChange("trigger_message", event, index, false)
            }
          />
        </div>
       */}
      </div>
      {totalEntries !== index && totalEntries !== 0 && (
        <div
          className="wfconditionslist-lg-wrapper"
          onMouseEnter={toggleLogicalOperatorVisibility}
          onMouseLeave={toggleLogicalOperatorVisibility}>
          <div className="wfconditionslist-label">
            {logicalOperator}{" "}
            <span>
              <FontAwesomeIcon icon={["far", "angle-down"]} />
            </span>
          </div>
          {showOperators && (
            <div
              className="wfconditionslist-lg-options"
              onClick={() =>
                onSelectChange("logicalOperator", _decideOperator(data))
              }
              onKeyPress={() =>
                onSelectChange("logicalOperator", _decideOperator(data))
              }
              role="button"
              tabIndex="0">
              {_decideOperator(data)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WFConditionsList;
